import { useId } from 'react'
import { AnimatedNumber, Text } from '@lounge-fe/ui-kit'
import { StatProps } from './types'

export const Stat = ({
  value,
  heading,
  subheading,
  prefix,
  suffix,
  duration = 1.5,
  className,
}: StatProps) => {
  const headingId = useId()

  return (
    <figure
      className={className}
      role="region"
      aria-labelledby={heading ? headingId : undefined}
    >
      {heading && (
        <figcaption>
          <Text variant="title-five" id={headingId}>
            {heading}
          </Text>
        </figcaption>
      )}
      <AnimatedNumber
        value={value}
        prefix={prefix}
        suffix={suffix}
        duration={duration}
        /** TODO: Add typography to display system
         * stray away from using hardcoded font styles
         * and use a typography system instead
         */
        className="font-display text-[64px] tracking-[1.28px] leading-[86px]"
        aria-describedby={heading ? headingId : undefined}
      />
      {subheading && <Text variant="title-six">{subheading}</Text>}
    </figure>
  )
}
